import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import SBProTopNav from '@structural/top-nav.vue';
import SBProPageHeader from '@structural/page-header.vue';
import SBProLayoutDefault from '@structural/layout-default.vue';
import SBProPageSection from '@structural/page-section.vue';
let BlogArchive = class BlogArchive extends Vue {
    data() {
        return {
            articles: [
                { id: 1, title: '如何识别常见的合同陷阱', pay: '付费阅读' },
                { id: 2, title: '劳动法解读：员工权益知多少', pay: '付费阅读' },
                { id: 3, title: '离婚财产分割的法律要点', pay: '付费阅读' },
                { id: 4, title: '知识产权保护的基本原则', pay: '付费阅读' },
                { id: 5, title: '租房注意事项：法律保障你的权益', pay: '付费阅读' },
                { id: 6, title: '交通事故后如何正确维权', pay: '付费阅读' },
                { id: 7, title: '未成年人保护法的主要内容', pay: '付费阅读' },
                { id: 8, title: '如何合法制定遗嘱', pay: '付费阅读' },
                { id: 9, title: '消费者权益保护法解读', pay: '付费阅读' },
                { id: 10, title: '网络犯罪的防范与应对', pay: '付费阅读' }
            ]
        };
    }
    goPay(id) {
        this.$bvModal.show("modal-pay");
    }
};
BlogArchive = __decorate([
    Component({
        components: {
            'sbpro-top-nav': SBProTopNav,
            'sbpro-page-header': SBProPageHeader,
            'sbpro-layout-default': SBProLayoutDefault,
            'sbpro-page-section': SBProPageSection,
        },
    })
], BlogArchive);
export default BlogArchive;
